import { useQuery } from "@apollo/client/react";
import { Link } from "react-router-dom";
import { CreditCard } from "lucide-react";

import { GET_BILLING_STATUS } from "@/graphql/queries/students";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import {
  CancelSubscriptionButton,
  subscriptionSentence,
} from "@/components/billing/subscription-controls";

/**
 * The subscription on the settings page, with its cancel button.
 *
 * Directive 2023/2673 wants cancelling to be as easy to find as buying, and
 * „Nustatymai" is where a parent looks for it — so the button is here as well as
 * on „Prenumerata ir kreditai", rather than a link to a page that has it.
 */
export function SubscriptionSettings() {
  const { data } = useQuery(GET_BILLING_STATUS, { fetchPolicy: "cache-and-network" });
  const status = (data as any)?.billingStatus;

  // No account behind the session, or payments off: nothing to cancel here.
  if (!status || !status.paymentsEnabled) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <CreditCard className="h-5 w-5" />
          Prenumerata
        </CardTitle>
        <CardDescription>
          {status.stripeSubscription
            ? subscriptionSentence(status)
            : status.subscribed
              ? `Prenumerata aktyvi${status.subscribedUntil ? ` iki ${status.subscribedUntil}` : ""}.`
              : "Prenumeratos nėra."}
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap gap-3">
        {status.cancelable && <CancelSubscriptionButton />}
        <Button variant="ghost" asChild>
          <Link to="/billing">Prenumerata ir kreditai</Link>
        </Button>
      </CardContent>
    </Card>
  );
}
